import React, { Component } from 'react';
import i18n from 'i18next'; import './ThankYou.scss';

class ThankYou extends Component {
    render() {
        return (<div className='fl-engagement-thank-you'>{ i18n.t('engagement.thank_you') }</div>);
    }
}

export default ThankYou;
